import {
    customUtagOptionsResolver,
    PATH_IDENTITY_VIDEOCALL_EVENT,
    PATH_IDENTITY_VIDEOSELFIE_EVENT,
} from 'constants/uTagConstants/paths';
import { ABORTED } from 'constants/video/status';
import { formatText } from 'core/i18n';

export const EVENT_VIDEOCALL_START = customUtagOptionsResolver({
    pasoProceso: PATH_IDENTITY_VIDEOCALL_EVENT,
    detalleProceso: 'comienzo',
});
export const EVENT_VIDEOCALL_FINISHED = customUtagOptionsResolver({
    pasoProceso: PATH_IDENTITY_VIDEOCALL_EVENT,
    detalleProceso: 'finalizado',
});

export const EVENT_VIDEOSELFIE_START = customUtagOptionsResolver({
    pasoProceso: PATH_IDENTITY_VIDEOSELFIE_EVENT,
    detalleProceso: 'comienzo',
});
export const EVENT_VIDEOSELFIE_FINISHED = customUtagOptionsResolver({
    pasoProceso: PATH_IDENTITY_VIDEOSELFIE_EVENT,
    detalleProceso: 'finalizado',
});

export const EVENT_CALLCENTER_KO = customUtagOptionsResolver({
    categoriaError: ABORTED,
    descripcionError: formatText('messagesScreen-identityVerificationInProcessContent'),
});
export const TEALIUM_IDENTITY_NAME = {
    videoselfie: 'identitySelfie',
    iban: 'identityIban',
    videoconferencia: 'identityVideocall',
};
